<template>
    <div :class="{
            'ldc-option-mobile-item px-3': true,
        }" v-if="$detect == 'mobile' && show" @click="selectOption()">
        <div v-if="$isAndroid">
            <i :class="{
                'icon mr-3': true,
                'ion-md-radio-button-off': model !== value || (labelModel === '' && value === ''),
                'ion-md-radio-button-on text-primary': model === value && labelModel !== '',
            }"></i> <span>{{label}}</span>
        </div>
        <div v-else :class="{
                'position-relative': true,
                'active-ios-option text-primary': model === value && labelModel !== '',
            }">
            <span>{{label}}</span>
            <i class="ion ion-md-checkmark position-absolute" v-if="model === value && labelModel !== ''"></i>
        </div>
    </div>
</template>
<script>
export default {
    props: ['value', 'label'],
    data() {
        return{
            show: true,
            model: '',
            labelModel: '',
        }
    },
    created() {
        if(this.$detect != 'mobile'){
            console.error('Component ldc-select-mobile chỉ hoạt động trên mobile');
        }
    },
    mounted(){
        let parent = this.$parent;
        if(parent && parent.$vnode && parent.$vnode.componentOptions
            && parent.$vnode.componentOptions.tag == 'ldc-select-mobile'){
                if(this.value != undefined && this.label != undefined){
                    this.show = true;
                    if(this.checkPush(parent.$data.options)){
                        parent.$data.options.push({
                            value: this.value,
                            label: this.label
                        })
                    }else{
                        console.warn('Component ldc-option-mobile có data trùng với 1 Component ldc-option-mobile khác, việc này sẽ k hiển thị component ldc-option-mobile trùng')
                    }
                }else{
                    console.error('Vui lòng truyền prop value và label khác undefined');
                    this.show = false
                }
            }else{
                console.error('Component ldc-option-mobile chỉ hoạt động trong component ldc-select-mobile');
                this.show = false;
            }
    },
    methods: {
        checkPush(options){
            let check = true;
            options.map(item => {
                if(item.value === this.value && item.label === this.label){
                    check = false;
                }
            });
            return check;
        },
        selectOption(){
            this.$parent.$data.data = this.value;
            this.$parent.$data.model = this.label;
            if(this.$parent.$props.selectClose){
                this.$parent.$data.active = false;
            }
            setTimeout(() => {
                if(this.$parent.$data.change) this.$parent.$data.change();
            }, 0)
        },
    }
}
</script>